import Component from "@glimmer/component";
import { cached } from "@glimmer/tracking";
import { LinkTo } from "@ember/routing";
import gButtonColors from "glesys-controlpanel/helpers/g-button-color";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import Content from "./content";

export default class GButtonLinkTo extends Component {
  get models() {
    const models = this.args.model ? [this.args.model] : this.args.models;
    return models ?? [];
  }

  @cached
  get query() {
    return this.args.query ?? {};
  }

  get isDisabled() {
    return this.args.disabled || this.args.isLoading;
  }

  get stateClasses() {
    return this.isDisabled ? "cursor-not-allowed pointer-events-none" : "cursor-pointer";
  }

  get displayClasses() {
    return this.args.display === "compact" ? "px-2 py-1" : "px-4 py-2";
  }

  <template>
    <LinkTo
      class="flex items-center relative rounded-sm text-sm
        {{this.displayClasses}}
        {{this.stateClasses}}
        {{gButtonColors @color}}"
      @route={{@route}}
      @models={{this.models}}
      @query={{this.query}}
      @disabled={{this.isDisabled}}
      {{mergeClasses}}
      ...attributes
    >
      <Content @loading={{@isLoading}} @color={{@color}}>
        {{yield}}
      </Content>
    </LinkTo>
  </template>
}
